import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Button } from "@/shared/ui/Button";
import { Modal } from "@/shared/ui/Modal";
import { TextField } from "@/shared/ui/TextField";
import styles from "./RenameAudioModal.module.scss";
// Сервер режет title до 100 символов — ограничиваем и на вводе.
const MAX_TITLE_LENGTH = 100;
/**
 * Переименование трека (поварьянтно). Инпут с префиллом текущего имени;
 * «Сохранить» доступно, только если поле непустое и отличается от исходного.
 */
export const RenameAudioModal = ({ opened, onClose, initialTitle, onSubmit, language, }) => {
    const [value, setValue] = useState(initialTitle);
    // Пересеиваем инпут при каждом открытии (другой трек / повторный вход).
    useEffect(() => {
        if (opened)
            setValue(initialTitle);
    }, [opened, initialTitle]);
    const trimmed = value.trim();
    const canSave = trimmed.length > 0 && trimmed !== initialTitle.trim();
    const handleSave = () => {
        if (!canSave)
            return;
        onSubmit(trimmed);
    };
    return (_jsxs(Modal, { opened: opened, onClose: onClose, size: "sm", title: language === "ru" ? "Переименовать" : "Rename", children: [_jsx(TextField, { value: value, maxLength: MAX_TITLE_LENGTH, onChange: (e) => setValue(e.target.value), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleSave();
                    }
                }, placeholder: language === "ru" ? "Название трека" : "Track title" }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { variant: "ghost", size: "md", onClick: onClose, children: language === "ru" ? "Отмена" : "Cancel" }), _jsx(Button, { variant: "primary", size: "md", onClick: handleSave, disabled: !canSave, children: language === "ru" ? "Сохранить" : "Save" })] })] }));
};
